import axios from 'axios';
import { createLog } from '../admin';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const WS_API_KEY = process.env.REACT_APP_WS_API_KEY || '';

const buildHeaders = (storeId: string | number) => ({
    accept: '*/*',
    'WS-API-KEY': WS_API_KEY,
    'Content-Type': 'application/json',
    'WS-STORE-ID': String(storeId),
});

export const getCustomizationSection = async <T>(storeId: string | number, metafield: string): Promise<T> => {
    const response = await axios.get(`${API_BASE_URL}ws/Customization/GetMetafield/${metafield}`, {
        headers: buildHeaders(storeId),
    });

    return response.data as T;
};

export const uploadCustomizationImage = async (storeId: string | number, file: File): Promise<string> => {
    const formData = new FormData();
    formData.append('image', file);

    const response = await axios.post(`${API_BASE_URL}ws/Assets/UploadImage`, formData, {
        headers: { ...buildHeaders(storeId), 'Content-Type': 'multipart/form-data' },
        responseType: 'text',
    });

    if (!response.data) throw new Error('No image URL returned from API');

    return response.data;
};

type SaveCustomizationSection = {
    storeId: string | number;
    metafield: string;
    section: string;
    payload: unknown;
    lastValue?: unknown;
    newValue?: unknown;
    action?: string;
};

export const saveCustomizationSection = async ({ storeId, metafield, section, payload, lastValue, newValue, action = 'save' }: SaveCustomizationSection): Promise<void> => {
    await axios.post(`${API_BASE_URL}ws/Customization/UpsertMetafield/${metafield}`, payload, {
        headers: buildHeaders(storeId),
    });

    createLog({
        storeId: Number(storeId),
        entityType: 'customization',
        section,
        action,
        lastValue,
        newValue: newValue ?? payload,
    });
};
